import { render, staticRenderFns } from "./SizeSelect.vue?vue&type=template&id=52175a12&scoped=true"
import script from "./SizeSelect.vue?vue&type=script&lang=js"
export * from "./SizeSelect.vue?vue&type=script&lang=js"
import style0 from "./SizeSelect.vue?vue&type=style&index=0&id=52175a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52175a12",
  null
  
)

export default component.exports